export const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '')

export const withTrailingSlash = (value: string): string => `${trimTrailingSlash(value)}/`

// Root-relative CMS links ("/about-us/") point at the WP origin, not this site's
// own routes — absolute URLs pass through untouched.
export const resolveWpOriginUrl = (url: string, wpOriginUrl: string): string => (
  url.startsWith('/') ? `${trimTrailingSlash(wpOriginUrl)}${url}` : url
)
